import { gql } from "@apollo/client";

export const CONSULTAR_CIERRE_PERIODO = gql`
query ConsultarCierrePeriodo {
    consultaConexionesPeriodo {
        success
        error
        valorEsperado {
            cantidad
            delegacion
        }
    }
}`;

export const adaptCierrePeriodo = (data) => {
  if (!data || !data.consultaConexionesPeriodo) return [];

  const { valorEsperado } = data.consultaConexionesPeriodo;

  return valorEsperado.map(({ cantidad, delegacion }) => ({
    cantidad,
    delegacion
  }));
};